// extracted by mini-css-extract-plugin
module.exports = {"nav":"NavBar_nav__xAdj3","nav-item":"NavBar_nav-item__3FbcW","nav-link":"NavBar_nav-link__2PcoG"};